import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  width: {
    default: '1000px',
    editor: 'textbox',
  },
  height: {
    default: '',
    editor: 'textbox',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A simple static 2-level navigation left-hand sidebar',
  coreComponent: {
    html: `<div style="display:flex;">
  <tag-nav-simple initial-selected-group="transactions" initial-selected-item="successfulTransactions" {{...knobs}}'>
    <div slot="groups">
      <tag-nav-simple-group name="employees" icon="User" text="Employees" ></tag-nav-simple-group>
      <tag-nav-simple-group name="transactions" icon="Pound1" text="Transactions" blob="access"></tag-nav-simple-group>
      <tag-nav-simple-group name="payPeriods" icon="Calendar" text="Pay Periods"></tag-nav-simple-group>
      <tag-nav-simple-group name="uploadData" icon="Upload" text="Upload Data" blob="access"></tag-nav-simple-group>
    </div>
    <div id="items" slot="items">
      <tag-nav-simple-item group="employees" name="allEmployees" text="All" right-text="1561"></tag-nav-simple-item>
      <tag-nav-simple-item group="employees" name="activeEmployees" text="Active" right-text="350"></tag-nav-simple-item>
      <tag-nav-simple-item group="transactions" name="allTransactions" text="All" right-text="201"></tag-nav-simple-item>
      <tag-nav-simple-item group="transactions" name="successfulTransactions" badge-accent text="Successful" right-text="193" blob="access"></tag-nav-simple-item>
      <tag-nav-simple-item group="transactions" name="failedTransactions" text="Failed" right-text="8"></tag-nav-simple-item>
      <tag-nav-simple-item group="payPeriods" name="allPayPeriods" text="All" right-text="63" blob="access"></tag-nav-simple-item>
      <tag-nav-simple-item group="payPeriods" name="openPayPeriods" text="Successful" right-text="5"></tag-nav-simple-item>
      <tag-nav-simple-item group="uploadData" name="newEmployees" text="New Employees"></tag-nav-simple-item>
      <tag-nav-simple-item group="uploadData" name="employeeUpdates" text="Employee Updates" blob="access"></tag-nav-simple-item>
      <tag-nav-simple-item group="uploadData" name="bankAccountChanges" text="Bank Account Changes"></tag-nav-simple-item>
    </div>
  </tag-nav-simple>
  <div style="background: white; padding: 10px 20px; min-width: 300px;">
    <tag-text id="status"></tag-text>
  </div></div>`,
    knobs: PlaygroundKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    knobs: PlaygroundKnobs,
    parentJSX: `Example = () => {
    return (
      <div style={{ display: 'flex' }}>
      <TagNavSimple
      initialSelectedGroup="Transactions"
      initialSelectedItem="SuccessfulTransactions"
      onGroupClick={this.groupClicked}
      onItemClick={this.itemClicked}
      {{...knobs}}
    >
      <div slot="groups">
        <TagNavSimpleGroup name="Employees" icon="User" text="Employees" blob="access" />
        <TagNavSimpleGroup name="Transactions" icon="Pound1" text="Transactions" />
        <TagNavSimpleGroup name="PayPeriods" icon="Calendar" text="Pay Periods" />
        <TagNavSimpleGroup name="UploadData" icon="Upload" text="Upload Data" />
      </div>
      <div id="items" slot="items">
        <TagNavSimpleItem group="Employees" name="AllEmployees" text="All" rightText="1561" />
        <TagNavSimpleItem
          group="Employees"
          name="ActiveEmployees"
          text="Active"
          rightText="350"
          blob="access"
        />
        <TagNavSimpleItem
          group="Transactions"
          name="AllTransactions"
          text="All"
          rightText="201"
        />
        <TagNavSimpleItem
          group="Transactions"
          name="SuccessfulTransactions"
          text="Successful"
          rightText="193"
        />
        <TagNavSimpleItem
          group="Transactions"
          name="FailedTransactions"
          text="Failed"
          rightText="8"
        />
        <TagNavSimpleItem group="PayPeriods" name="AllPayPeriods" text="All" rightText="63" />
        <TagNavSimpleItem
          group="PayPeriods"
          name="OpenPayPeriods"
          text="Successful"
          rightText="5"
        />
        <TagNavSimpleItem group="UploadData" name="NewEmployees" text="New Employees" />
        <TagNavSimpleItem group="UploadData" name="EmployeeUpdates" text="Employee Updates" />
        <TagNavSimpleItem
          group="UploadData"
          name="BankAccountChanges"
          text="Bank Account Changes"
        />
      </div>
    </TagNavSimple>
    </div>
    )
    };`,
  },
};

const ProgammaticallyNavigatingStory: Story = {
  title: 'Progammatically navigating',
  description: 'Example of a navigation option being programatically selected',
  coreComponent: {
    html: `<div style="display:flex;">
    <tag-nav-simple height='300px' width='250px' initial-selected-group="employees" initial-selected-item="allEmployees">
      <div slot="groups">
        <tag-nav-simple-group name="employees" icon="User" text="Employees" ></tag-nav-simple-group>
        <tag-nav-simple-group name="transactions" icon="Pound1" text="Transactions" blob="access"></tag-nav-simple-group>
      </div>
      <div id="items" slot="items">
        <tag-nav-simple-item group="employees" name="allEmployees" text="All" right-text="1561"></tag-nav-simple-item>
        <tag-nav-simple-item group="employees" name="activeEmployees" text="Active" right-text="350"></tag-nav-simple-item>
        <tag-nav-simple-item group="transactions" name="allTransactions" text="All" right-text="201"></tag-nav-simple-item>
        <tag-nav-simple-item group="transactions" name="successfulTransactions" badge-accent text="Successful" right-text="193" blob="access"></tag-nav-simple-item>
      </div>
    </tag-nav-simple>
    <div style="background: white; padding: 10px 20px; min-width: 300px;">
      <tag-button text="Go to successful transations"></tag-button>
    </div>
  </div>`,
    js: `var button = document.querySelector('tag-button');
  var nav = document.querySelector('tag-nav-simple');
  button.componentOnReady().then(function() {
    button.addEventListener('buttonClick', function() {
      nav.select('transactions', 'successfulTransactions');
    });
  });
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return (
      <div style={{ display: 'flex' }}>
      <TagNavSimple
      initialSelectedGroup="Employees"
      initialSelectedItem="AllEmployees"
      onGroupClick={this.groupClicked}
      onItemClick={this.itemClicked}
      height='300px'
      width='250px'
    >
      <div slot="groups">
        <TagNavSimpleGroup name="Employees" icon="User" text="Employees" blob="access" />
        <TagNavSimpleGroup name="Transactions" icon="Pound1" text="Transactions" />
      </div>
      <div id="items" slot="items">
        <TagNavSimpleItem group="Employees" name="AllEmployees" text="All" rightText="1561" />
        <TagNavSimpleItem
          group="Employees"
          name="ActiveEmployees"
          text="Active"
          rightText="350"
          blob="access"
        />
        <TagNavSimpleItem
          group="Transactions"
          name="AllTransactions"
          text="All"
          rightText="201"
        />
        <TagNavSimpleItem
          group="Transactions"
          name="SuccessfulTransactions"
          text="Successful"
          rightText="193"
        />
      </div>
    </TagNavSimple>
    <div style={{padding: "10px 20px"}}>
    <TagButton text="Go to successful transations"
     onButtonClick={() => {
      nav = document.querySelector('tag-nav-simple');
      nav.select('Transactions', 'SuccessfulTransactions');}}/>
    </div>
    </div>
    )
    };`,
  },
};

const CustomStylesStory: Story = {
  title: 'Custom styles',
  description: 'A tag-nav-simple where some of the standard styles have been overriden',
  coreComponent: {
    html: `<div style="display:flex;">
    <tag-nav-simple
      initial-selected-group="transactions"
      initial-selected-item="successfulTransactions"
      groups-container-style='{"background-color": "#4c5265"}'
      items-container-style='{"background-color": "#555b70"}' >
      <div slot="groups">
        <tag-nav-simple-group name="employees" icon="User" text="Employees" ></tag-nav-simple-group>
        <tag-nav-simple-group name="transactions" icon="Pound1" text="Transactions" blob="access"></tag-nav-simple-group>
        <tag-nav-simple-group name="payPeriods" icon="Calendar" text="Pay Periods" blob="access"></tag-nav-simple-group>
        <tag-nav-simple-group name="uploadData" icon="Upload" text="Upload Data" icon-accent="sunflower" ></tag-nav-simple-group>
      </div>
      <div id="items" slot="items">
        <tag-nav-simple-item group="employees" name="allEmployees" text="All" right-text="1561"></tag-nav-simple-item>
        <tag-nav-simple-item group="employees" name="activeEmployees" text="Active" right-text="350"></tag-nav-simple-item>
        <tag-nav-simple-item group="transactions" name="allTransactions" text="All" right-text="201" blob="access"></tag-nav-simple-item>
        <tag-nav-simple-item group="transactions" name="successfulTransactions" text="Successful" right-text="193"></tag-nav-simple-item>
        <tag-nav-simple-item group="transactions" name="failedTransactions" text="Failed" right-text="8" item-accent="tango"></tag-nav-simple-item>
        <tag-nav-simple-item group="payPeriods" name="allPayPeriods" text="All" right-text="63" blob="access"></tag-nav-simple-item>
        <tag-nav-simple-item group="payPeriods" name="openPayPeriods" text="Successful" right-text="5"></tag-nav-simple-item>
        <tag-nav-simple-item group="uploadData" name="newEmployees" text="New Employees" blob="access"></tag-nav-simple-item>
        <tag-nav-simple-item group="uploadData" name="employeeUpdates" text="Employee Updates"></tag-nav-simple-item>
        <tag-nav-simple-item group="uploadData" name="bankAccountChanges" text="Bank Account Changes"></tag-nav-simple-item>
      </div>
    </tag-nav-simple>
    <div style="background: white; padding: 10px 20px; min-width: 300px;">
      <tag-text id="status"></tag-text>
    </div></div>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: {
    jsx: `<TagNavSimple
  initialSelectedGroup="Transactions"
  initialSelectedItem="SuccessfulTransactions"
  onGroupClick={this.groupClicked}
  onItemClick={this.itemClicked}
  groupsContainerStyle={{ backgroundColor: '#4c5265' }}
  itemsContainerStyle={{ backgroundColor: '#555b70' }}
  {{...knobs}}
>
  <div slot="groups">
    <TagNavSimpleGroup name="Employees" icon="User" text="Employees" blob="access" />
    <TagNavSimpleGroup name="Transactions" icon="Pound1" text="Transactions" />
    <TagNavSimpleGroup name="PayPeriods" icon="Calendar" text="Pay Periods" />
    <TagNavSimpleGroup name="UploadData" icon="Upload" text="Upload Data" icon-accent="sunflower" />
  </div>
  <div id="items" slot="items">
    <TagNavSimpleItem group="Employees" name="AllEmployees" text="All" rightText="1561" />
    <TagNavSimpleItem
      group="Employees"
      name="ActiveEmployees"
      text="Active"
      rightText="350"
      blob="access"
    />
    <TagNavSimpleItem
      group="Transactions"
      name="AllTransactions"
      text="All"
      rightText="201"
    />
    <TagNavSimpleItem
      group="Transactions"
      name="SuccessfulTransactions"
      text="Successful"
      rightText="193"
    />
    <TagNavSimpleItem
      group="Transactions"
      name="FailedTransactions"
      text="Failed"
      rightText="8"
      itemAccent="tango"
    />
    <TagNavSimpleItem group="PayPeriods" name="AllPayPeriods" text="All" rightText="63" />
    <TagNavSimpleItem
      group="PayPeriods"
      name="OpenPayPeriods"
      text="Successful"
      rightText="5"
    />
    <TagNavSimpleItem group="UploadData" name="NewEmployees" text="New Employees" />
    <TagNavSimpleItem group="UploadData" name="EmployeeUpdates" text="Employee Updates" />
    <TagNavSimpleItem
      group="UploadData"
      name="BankAccountChanges"
      text="Bank Account Changes"
    />
  </div>
</TagNavSimple>`,
  },
};

export const TagNavSimpleGroupDocs: Component = {
  type: 'component',
  name: 'nav-simple-group',
  description: 'Displays a group in tag-nav-simple',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      type: 'string',
      description: 'The name of the group',
    },
    {
      name: 'text',
      type: 'string',
      description: 'The caption for the group',
    },
    {
      name: 'icon',
      type: 'Icon',
      description: 'The icon for the group',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'simpleNavGroupClick',
      description: 'Raised when a group is clicked',
      parameters: [
        {
          name: 'group ',
          description: 'The group that was clicked',
          type: '{ name: string, text: string, icon: Icon }',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagNavSimpleItemDocs: Component = {
  type: 'component',
  name: 'nav-simple-item',
  description: 'Displays a item in tag-nav-simple',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      type: 'string',
      description: 'The name of the item',
    },
    {
      name: 'text',
      type: 'string',
      description: 'The caption for the item',
    },
    {
      name: 'rightText',
      type: 'string',
      description: 'Addition information for the item',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'simpleNavItemClick',
      description: 'Raised when an item is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The item that was clicked',
          type: '{ name: string, text: string, rightText: string }',
        },
      ],
    },
  ],
  methods: [],
  stories: [],
};

export const TagNavSimpleDocs: Component = {
  type: 'component',
  name: 'nav-simple',
  description: 'Displays a simple left hand navigation menu',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'initialSelectedGroup',
      type: 'string',
      description: 'The name of the group that is initially selected',
    },
    {
      name: 'initialSelectedItem',
      type: 'string',
      description: 'The name of the item that is initially selected',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'simpleNavGroupClick',
      description: 'Raised when a group is clicked',
      parameters: [
        {
          name: 'group',
          description: 'The group that was clicked',
          type: '{ name: string, text: string, icon: Icon }',
        },
      ],
    },
    {
      name: 'simpleNavItemClick',
      description: 'Raised when an item is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The item that was clicked',
          type: '{ name: string, text: string, rightText: string }',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'select',
      description: 'Sets the selected group and item in the nav bar',
      parameters: [
        {
          name: 'groupName',
          description: 'The name of the group to select',
          type: 'string',
        },
        {
          name: 'itemName',
          description: 'The name of the item to select',
          type: 'string',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [BasicStory, ProgammaticallyNavigatingStory, CustomStylesStory],
  childComponents: [TagNavSimpleGroupDocs, TagNavSimpleItemDocs],
};
